export const PER_PAGE_OPTION = 20

export const BLOG_ARTICLES_PER_PAGE_OPTION = 4
export const BLOG_RECOMMENDED_PER_PAGE_OPTION = 4